import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Tile, { TileIcon, TileLabel, TileLabels, TileSubLabel } from '@/components/ui/Tile/Tile';
import { useGetAuthApi } from '@/hooks/UseApiCalls';
import { ProjectDtoIn } from '@/models/in/ProjectDtoIn';
import projectsIcon from '@/assets/icons/projects.svg';

interface ProjectsEntryTileProps {
  fundId?: number;
}

/**
 * "הוצאות פרויקט" — the entry point to the projects list, sitting among the fund-expense goals
 * as the designer placed it (5292:45904) rather than as a sidebar tab. The sub-label carries the
 * fund's project count, which is why this tile fetches the list rather than taking a prop.
 */
const ProjectsEntryTile = ({ fundId }: ProjectsEntryTileProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fundId: routeFundId } = useParams();

  const { data: projects } = useGetAuthApi<ProjectDtoIn[]>(fundId ? `funds/${fundId}/projects` : '');
  const count = projects?.length ?? 0;

  return (
    <Tile onClick={() => navigate(`/${routeFundId}/projects/list`)}>
      <TileIcon src={projectsIcon} alt="" />
      <TileLabels>
        <TileLabel>{t('projects.entryTile.label')}</TileLabel>
        <TileSubLabel text={t('projects.entryTile.count', { count })} />
      </TileLabels>
    </Tile>
  );
};

export default ProjectsEntryTile;
